module.exports = __webpack_public_path__ + "img/4-5porte.4b2e6b42.webp";